import { render } from "./ChannelDetail.vue?vue&type=template&id=5c3798e2&scoped=true"
import script from "./ChannelDetail.vue?vue&type=script&lang=js"
export * from "./ChannelDetail.vue?vue&type=script&lang=js"

import "./ChannelDetail.vue?vue&type=style&index=0&id=5c3798e2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c3798e2"]])

export default __exports__